import "../../assets/TextLink.css";
import { jsxs as o, jsx as n, Fragment as f } from "react/jsx-runtime";
import { c as u } from "../../index-LULxUVKG.js";
import { forwardRef as k } from "react";
import { isExternalLink as w } from "../../utils/utils.js";
import { Icon as _ } from "../Icon/Icon.js";
import { VisuallyHidden as x } from "../VisuallyHidden/VisuallyHidden.js";
const g = "_link_4qvw1_3", h = "_underline_4qvw1_21", t = {
  link: g,
  underline: h
}, T = k(
  ({
    href: e,
    children: s,
    opensInNewWindow: r = !1,
    rel: i,
    target: l,
    className: a,
    ...m
  }, d) => {
    const c = w(e) ? `${i || ""} noopener`.trim() : i, p = r ? "_blank" : l;
    return /* @__PURE__ */ o(
      "a",
      {
        className: u(t.link, a),
        href: e,
        rel: c,
        target: p,
        ...m,
        ref: d,
        children: [
          /* @__PURE__ */ n("span", { className: t.underline, children: s }),
          r && /* @__PURE__ */ o(f, { children: [
            /* @__PURE__ */ n(x, { children: " (opens in new window)" }),
            " ",
            /* @__PURE__ */ n(_, { name: "new-window", size: "0.8em" })
          ] })
        ]
      }
    );
  }
);
export {
  T as TextLink
};
